/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const ApiSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.1em"
    height="1.1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 8l-4 4 4 4"/>
    <path d="M17 8l4 4-4 4"/>
    <path d="M14 4l-4 16"/>
  </svg>
);

export const ApiIcon = (props) => (
  <Icon component={ApiSvg} {...props} />
);
